module.exports = __webpack_public_path__ + "static/fabric-table-expandable-basic-a224c97a1b5166332a9ae43bd474d54e.png";